 function bundlyAddLinksToSlots() {
    const slotTitles = document.querySelectorAll('.bundly__slot_title');
    slotTitles.forEach(slotTitle => {
      const baseUrl = slotTitle.closest('.bundly__block').dataset.url;
      const slotComponentIndex = slotTitle.closest('.bundly__slot').dataset.componentIndex;
      const urlState = Bundly.urlStateBuilder.buildStateWithParams({ currentComponentIndex: slotComponentIndex });
      const link = document.createElement('a');
      link.href = `${baseUrl}/${urlState}`;
      slotTitle.parentNode.insertBefore(link, slotTitle);
      link.appendChild(slotTitle);
    });
  }

  window.addEventListener('load', () => {  
    bundlyAddLinksToSlots();
  });
  document.addEventListener('bundly:afterUpdateBlock', () => {
    bundlyAddLinksToSlots();
  });

  /* Auswahlmenü mobil verkleinert Anzeigen (Sichtbarkeit Produkte) */
document.addEventListener('bundly:beforeUpdateBlock', (e) => {
  e.detail.serverResponse = e.detail.serverResponse.replaceAll('bundly__details bundly__details--visible', 'bundly__details');
});


// custom.js
(function() {



  
  // Entfernt <a> und (bei header) fügt toggle-Klasse hinzu
  function cleanBundly(root = document) {
   
    
    // Alle Slot-Titel sammeln
    const slotTitles = document.querySelectorAll('.bundly__slot_title');
    const reihenfolge = [];

    slotTitles.forEach(slot => {
      // In jedem Slot den Produkttitel suchen
      const prod = slot.querySelector('.bundly__slot_product_title');
      if (prod && prod.textContent.trim()) {
        reihenfolge.push(prod.textContent.trim());
      }
    });

    // Label finden und den Text erweitern
    const lbl = document.getElementById('assembly-label');
    if (lbl && reihenfolge.length) {
      lbl.textContent = lbl.textContent + ': ' + reihenfolge.join(', ');
    }

    // 2) Komponententitel
    root.querySelectorAll('.bundly__component_title').forEach(function(div) {
      var link = div.querySelector('a');
      if (link) {
        div.textContent = link.textContent.trim();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    // initial
  

    cleanBundly();

    // MutationObserver auf ganzes Dokument verschieben
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Neu eingefügte Knoten checken
            cleanBundly(node);
          }
        });
      });
    });

    // Beobachte documentElement, sobald es existiert
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }, { once: true });  // optional: listener nach erstem Aufruf automatisch entfernen
})();

// Keep Shopify's native cookie banner centered and put accept on the right.
(function() {
  function isVisible(element) {
    if (!element) return false;

    var styles = window.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function updateCookieBanner() {
    var banner = document.getElementById('shopify-pc__banner');
    var buttons = banner ? banner.querySelector('.shopify-pc__banner__btns') : null;
    var acceptButton = document.getElementById('shopify-pc__banner__btn-accept');
    var declineButton = document.getElementById('shopify-pc__banner__btn-decline');
    var prefsActions = document.querySelector('.shopify-pc__prefs__header-actions');
    var savePrefsButton = document.getElementById('shopify-pc__prefs__header-save');
    var acceptPrefsButton = document.getElementById('shopify-pc__prefs__header-accept');
    var declinePrefsButton = document.getElementById('shopify-pc__prefs__header-decline');

    if (buttons && acceptButton && declineButton) {
      if (declineButton.nextElementSibling !== acceptButton) {
        buttons.insertBefore(declineButton, acceptButton);
      }

      if (acceptButton.nextElementSibling) {
        buttons.appendChild(acceptButton);
      }
    }

    if (prefsActions && savePrefsButton && declinePrefsButton && acceptPrefsButton) {
      if (prefsActions.firstElementChild !== savePrefsButton) {
        prefsActions.insertBefore(savePrefsButton, prefsActions.firstElementChild);
      }

      if (savePrefsButton.nextElementSibling !== declinePrefsButton) {
        prefsActions.insertBefore(declinePrefsButton, savePrefsButton.nextElementSibling);
      }

      if (acceptPrefsButton.nextElementSibling) {
        prefsActions.appendChild(acceptPrefsButton);
      }
    }

    if (document.body) {
      document.body.classList.toggle('shopify-pc-banner-visible', isVisible(banner));
    }
  }

  function initCookieBannerObserver() {
    updateCookieBanner();

    var observer = new MutationObserver(updateCookieBanner);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    });

    document.addEventListener('visitorConsentCollected', updateCookieBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieBannerObserver);
  } else {
    initCookieBannerObserver();
  }
})();

